export default __webpack_public_path__ + "static/media/IBMMultiUser.5974e7aa.svg";